define.alias("ember-truth-helpers/helpers/xor", "settings/helpers/xor");